// src/components/AuthModal/AuthBackground.jsx
// Fondo "gaming" animado (orbes + partículas + símbolos crypto) reutilizable.
// Portado del efecto de las landings Login/Register para usarlo tras el AuthModal.
import React from 'react';
import './AuthBackground.css';

const CRYPTO_SYMBOLS = ['₿', 'Ξ', '◎', '◈', '₮', '⬡'];

export default function AuthBackground() {
  return (
    <div className="ab-bg" aria-hidden="true">
      <div className="ab-orb ab-orb-1" />
      <div className="ab-orb ab-orb-2" />
      <div className="ab-orb ab-orb-3" />

      {Array.from({ length: 24 }).map((_, i) => (
        <div
          key={`p-${i}`}
          className="ab-particle"
          style={{
            left: `${Math.random() * 100}%`,
            animationDuration: `${6 + Math.random() * 10}s`,
            animationDelay: `${Math.random() * 8}s`,
            width: `${1.5 + Math.random() * 2.5}px`,
            height: `${1.5 + Math.random() * 2.5}px`,
            opacity: 0.15 + Math.random() * 0.35,
          }}
        />
      ))}

      {Array.from({ length: 8 }).map((_, i) => (
        <div
          key={`c-${i}`}
          className="ab-crypto-float"
          style={{
            left: `${8 + (i * 12) % 85}%`,
            animationDuration: `${14 + Math.random() * 12}s`,
            animationDelay: `${i * 1.8}s`,
            fontSize: `${0.7 + Math.random() * 0.6}rem`,
          }}
        >
          {CRYPTO_SYMBOLS[i % CRYPTO_SYMBOLS.length]}
        </div>
      ))}
    </div>
  );
}
